(function ($, njm) {
    'use strict';

    njm.views.articlesHero = Backbone.View.extend({

        /**
         * Initialize
         */
        initialize: function () {
            this.$holder = this.$('.holder');

            // execute view and listener
            this.listenToMedia(this.render.bind(this));
            this.render(this.getCurrentMedia());
        },

        /**
         * Render
         * @param {string} media
         */
        render: function (media) {
            // stop timer to avoid duplicate timers for the auto-scroll feature
			if (this.lastView) {
				if (this.lastView.medias.indexOf('tablet') > -1 || this.lastView.medias.indexOf('desktop') > -1) {
					//console.log(this.lastView.setInterval);
					clearInterval(this.lastView.setInterval);
				}
				
				this.lastView.close();
			}
            // append view based on media
            this.lastView = this.switchMedia(media);
        },

        /**
         * Switch View by media
         * @param media
         * @returns {Object}
         */
        switchMedia: function (media) {
            switch (media) {
                case 'mobile':
                    return this.renderMobile();

                case 'tablet':
				case 'desktop':
                    return this.renderDesktop();
            }
        },

        /**
         * Render Mobile
         * @returns {Object}
         */
        renderMobile: function () {
            return new njm.views.articlesHeroMobile({
                el: this.$holder
            });
        },

        /**
         * Render Desktop
         * @returns {Object}
         */
        renderDesktop: function () {
            return new njm.views.articlesHeroDesktop({
                el: this.$holder
            });
        }

    });
})(jQuery, njm);